<template>
  <div class="px-4 py-4">
    <div v-if="meta.version == '1' || meta.version=='2' || meta.version=='ext1'">
        <p>
       No additional details??? If not, ill remove this panel + details icon/button
        </p>
    </div>
  </div>
</template>

<script>
import * as portalContent from '@/js/models/portal-content.js';
export default {
  name: 'continuous-associations-drawer',
  data: () => ({

  }),
  computed:{
    meta(){
        const section_id = "continuous-associations";
        const screen = this.$route.params.screen;
        const version_meta = portalContent.getVersionMetadata(screen, section_id);
        return version_meta
      }
  },
  
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
